import React, {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { resolveLevelUrl } from "./LevelUtils";

export type LevelContextType = {
  levelUrl: string;
  setLevelUrl: (levelUrl: string) => void;
};

export const LevelContext = createContext<LevelContextType>({
  levelUrl: "",
  setLevelUrl: () => {},
});

export const useLevelController = () => useContext(LevelContext);

export const { Consumer: LevelConsumer, Provider: LevelProvider } =
  LevelContext;

export type LevelControllerProps = PropsWithChildren<{
  baseFolderUrl?: string;
  initialLevelUrl: string;
}>;

export const LevelController: FC<LevelControllerProps> = ({
  baseFolderUrl = "",
  initialLevelUrl = "",
  children,
}) => {
  const [levelUrl, setLevelUrlInternal] = useState<string>(initialLevelUrl);
  const setLevelUrl = useCallback(
    (levelUrl: string) =>
      setLevelUrlInternal(resolveLevelUrl(levelUrl, baseFolderUrl)),
    [setLevelUrlInternal]
  );
  const value = useMemo(
    () => ({ levelUrl, setLevelUrl }),
    [levelUrl, setLevelUrl]
  );

  return <LevelProvider value={value}>{children}</LevelProvider>;
};
